import pino from 'pino';
const config = {
    browser: { asObject: true },
    level: 'info',
} as pino.LoggerOptions;

export const logger = pino(config)